// ============================================================
// LOADING FALLBACK COMPONENT
// File: src/components/LoadingFallback.js
// Fallback UI for React.Suspense while lazy components load
// ============================================================

import React from 'react'
import { useTheme } from '../ThemeContext'

export default function LoadingFallback({ message = 'Loading...' }) {
  const { colors } = useTheme()

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      padding: '2rem'
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: `4px solid ${colors.border.primary}`,
        borderTop: '4px solid #2563eb',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <p style={{
        marginTop: '1rem',
        color: colors.text.secondary,
        fontSize: '1rem'
      }}>
        {message}
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
